import {actions as A} from '../constants/actions';

const defaultState = {
  tab1: {},
  tab2: {},
  tab3: {},
  tab4: {},
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.SAVE_TAB_1_FILTERS:
      return {...state, tab1: {...state.tab1, ...payload}};

    case A.SAVE_TAB_2_FILTERS:
      return {...state, tab2: {...state.tab2, ...payload}};

    case A.SAVE_TAB_3_FILTERS:
      return {...state, tab3: {...state.tab3, ...payload}};

    case A.SAVE_TAB_4_VALUES:
      return {...state, tab4: {...state.tab4, ...payload}};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

